import { render } from "./PageKaizenNew_v4.vue?vue&type=template&id=0071d404&scoped=true&ts=true"
import script from "./PageKaizenNew_v4.vue?vue&type=script&lang=ts"
export * from "./PageKaizenNew_v4.vue?vue&type=script&lang=ts"

import "./PageKaizenNew_v4.vue?vue&type=style&index=0&id=0071d404&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0071d404"]])

export default __exports__